const state = {
  dev: !process.env.NODE_ENV === "production",
  localhost: window.location.hostname === "localhost",
  msgTrackingState: {
    cart: false,
    purchase: false,
  },
};

const actions = {
  SET_TRACKING: ({ state }, { elem, value }) => {
    console.log("SET_TRACKING", { elem, value });
    state.msgTrackingState[elem] = value;

    console.log(state.msgTrackingState);
    window.localStorage.setItem(
      "msgTrackingState",
      JSON.stringify(state.msgTrackingState)
    );
  },
  GET_TRACKING: ({ state }) => {
    if (window.localStorage.getItem("msgTrackingState")) {
      const tracking = JSON.parse(
        window.localStorage.getItem("msgTrackingState")
      );
      console.log("GET_TRACKING", tracking);
      state.msgTrackingState = tracking;
    }
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
};
